import { render, staticRenderFns } from "./direct_register.vue?vue&type=template&id=e904f22a&"
import script from "./direct_register.vue?vue&type=script&lang=js&"
export * from "./direct_register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports